import { Movimiento, MovimientoPayload } from 'ducks/movimientos'

export const parseMovimientoData = (data: Array<Movimiento>): MovimientoPayload | undefined => {
  if (data.length > 0) {
    return { movimiento: data[0] }
  }
  return
}
